<template>
  <sui-segment>
	  <v-banner
	  v-if="success === 'true'"
		color="success lighten-2"
		style="text-align:center;"
		> {{$t("checkoutSuccess")}} </v-banner>
		    <v-simple-table fixed-header max-height="1300px">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="cart-row"></th>
            <th class="cart-row">{{ $t("name") }}</th>
            <th class="cart-row">{{ $t("amount") }}</th>
            <th class="cart-row">{{ $t("date") }}</th>
            <th class="cart-row">{{ $t("extras") }}</th>
            <th class="cart-row">{{ $t("status") }}</th>
            <th class="cart-row right"></th>
          </tr>
        </thead>
        <br />
        <tbody>
          <tr v-for="item in items" :key="item.id" style="padding: 120px">
            <td>
              <v-img :src="item.product.image" class="cartprod-img"></v-img>
            </td>
            <td>{{ item.product.name }}</td>
            <td>{{ item.amount }}</td>
			<td> {{ toHumanDate(item.created_at)}} </td>
            <td>{{renderExtras(item)}}</td>
			<td :title="item.accepted_by != 'none' ? toHumanDate(item.updated_at) : ''"> <span :style="'color:'+renderColor(item.status)">{{ $t(item.status)}}</span><br><span class="acceptor-subtitle">{{(item.accepted_by != "none" ? $t("by") + ": " : "")+$t(item.accepted_by)}}</span></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
	<hr>
	    <div class="cart-information">
      {{ $t("totalitems") }}: {{ totalamount }}<br />
      {{ $t("diffitems") }}: {{ diffitems }}<br />
    </div>
  </sui-segment>
</template>

<script>
import ApiService from "@/services/ApiService.js"
import DateService from "@/services/DateService.js"
export default {
	data(){
		return {
			success: false,
			items: {},
			totalamount: 0,
			diffitems: 0,
		}
	},
	async   mounted() {
    // const urlParams = new URLSearchParams(window.location.search);
    this.success = this.$route.query.success
      if(this.success == "true"){
        window.history.replaceState({},document.title,window.location.origin + window.location.pathname)
      }
	this.renderContent()
	},
	methods: {
		async renderContent(){
			let resp = await ApiService.getCheckedout()
			if(resp.status == 200){
				this.items = resp.data.checkedout
				this.diffitems = resp.data.diffitems
				this.totalamount = resp.data.totalamount
			}
		},
		toHumanDate(date){
			return DateService.toHumanDate(date)
		},
    	renderExtras(item){
			if(item.size == null && item.color == null){
				return this.$t("noData")
			}
			let out = "";
			if(item.size){
				out += this.$t("size") + ": " + item.size
			}
			if(item.color){
				out == "" ? "" : out += ", "
				out += this.$t("color") + ": " + item.color
			}
			return out;
		},
    renderColor(status){
      switch(status){
        case "pending":
          return "orange"
        case "accepted":
        case "closed":
          return "green"
        case "declined":
          return "red"
      }
    }
	}
}
</script>

<style>
.cartprod-img {
  max-height: 100px;
  max-width: 100px;
  margin: 20px;
}
.cart-row {
  max-width: 450px;
}
.cart-row.right {
  text-align: right;
}
.cart-information {
  text-align: right;
  margin-bottom: 40px;
  margin-top: 20px;
  margin-right: 3%;
}
.acceptor-subtitle {
  font-size: .8rem;
  font-style: italic;
}
</style>